import {useEffect, useState} from 'react';
import backIcon from 'images/back.png';
import styles from '../../../adminUser/userDetails/tabs/transactions/createTransaction.module.scss';
import {useNavigate, useParams} from 'react-router-dom';
import {Form, Select, Spin} from 'antd';
import {useMutation, useQuery} from '@apollo/client';
import {UPDATE_USER_TRADE} from 'graphql/mutations/trades';
import {toast} from 'react-toastify';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {GET_USER_TRADE_BY_ID} from 'graphql/queries/users';
import {GET_CAMPAIGN_TRANSACTIONS} from 'graphql/queries/campaign';
import {transactionStatusOptions, transactionTypes} from 'utils/constants';

const UpdateCampaignUserTrade = () => {
  const [type, setType] = useState('');

  const [transactionStatus, setTransactionStatus] = useState('');
  const navigate = useNavigate();
  const {tradeId} = useParams();

  const {data, loading: loadingTrade} = useQuery(GET_USER_TRADE_BY_ID, {
    variables: {
      tradeId,
    },
  });

  useEffect(() => {
    if (data?.getTradeById) {
      setTransactionStatus(data?.getTradeById?.transactionStatus);
      setType(data?.getTradeById?.type);
    }
  }, [data?.getTradeById]);

  const [updateTrade, {loading}] = useMutation(UPDATE_USER_TRADE);

  const handleUpdateTrade = () => {
    const optionalFields = {};
    if (transactionStatus) optionalFields.transactionStatus = transactionStatus;
    updateTrade({
      variables: {
        tradeId,
        input: {
          ...optionalFields,
          type,
        },
      },
      refetchQueries: [
        {
          query: GET_CAMPAIGN_TRANSACTIONS,
          variables: {
            offering: data?.getTradeById?.offering,
          },
        },
      ],
    })
      .then(({data: {updateTrade}}) => {
        if (updateTrade.__typename === 'Error') {
          toast.error(updateTrade.message);
        } else {
          toast.success('Trade Updated Successfully');
          navigate('/dashboard/campaigns');
        }
      })
      .catch(error => toast.error(error.message));
  };

  if (loadingTrade) {
    return (
      <div className={styles.loading}>
        <Spin />
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          src={backIcon}
          alt=""
          onClick={() => navigate('/dashboard/campaigns')}
        />
        <h1>Update Transaction</h1>
      </div>
      <div>
        <Form onFinish={handleUpdateTrade} layout="vertical">
          <Form.Item
            rules={[{required: true, message: 'Please select a type'}]}
            name="transactionStatus"
            label="Transaction Status"
            className={styles.width}
            initialValue={data?.getTradeById?.transactionStatus}>
            <Select
              defaultValue={data?.getTradeById?.transactionStatus}
              value={transactionStatus}
              onChange={e => setTransactionStatus(e)}>
              {transactionStatusOptions
                .filter(status =>
                  ['FUNDED', 'CREATED', 'SETTLED'].includes(status.value),
                )
                .map(data => (
                  <Select.Option key={data.value}>
                    <span>{data.label}</span>
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            rules={[{required: true, message: 'Please select a type'}]}
            name="type"
            label="Transaction Type"
            className={styles.width}
            initialValue={data?.getTradeById?.type}>
            <Select
              defaultValue={data?.getTradeById?.type}
              value={type}
              disabled
              onChange={e => setType(e)}>
              {transactionTypes.map(data => (
                <Select.Option key={data.value}>
                  <span>{data.label}</span>
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <SubmitButton disabled={loading} label="Update Trade" />
        </Form>
      </div>
    </div>
  );
};

export default UpdateCampaignUserTrade;
